import { FC } from "react";
import classNames from "classnames";
import EventsTrackWrapperClick from "../../../EventsTrack/wrappers/EventsTrackWrapperClick";
import styles from "./AppModalCloseIcon.module.scss";

const AppModalCloseIcon: FC = () => (
  <EventsTrackWrapperClick id={14}>
    <span className={classNames(styles.icon, "promo-icon-14")} />
  </EventsTrackWrapperClick>
);

export default AppModalCloseIcon;
